<template>
    <v-container fluid class="mb-4">
        <v-toolbar text dark color="secondary">
            <v-toolbar-title>Lista de turmas</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn text v-on="on" v-if="isAdmin">
                        <v-icon left>add</v-icon>
                        Adicionar turma
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 xm6>
                                    <v-select v-model="editedItem.ano_lectivo" label="Ano Lectivo" :items="anosLectivos" readonly :rules="[inputRules.required]"></v-select>
                                </v-flex>
                                <v-flex xs6>
                                    <v-select v-model="editedItem.ano" label="Ano" :items="anosCurriculares" :rules="[inputRules.required]"></v-select>
                                </v-flex>
                                <v-flex xs6>
                                    <v-text-field v-model="editedItem.designacao" label="Designação" :rules="[inputRules.required]"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" text @click="resetEditedData">Cancelar</v-btn>
                        <v-btn color="secondary" text @click="save">Gravar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

			<!-- TODO: usar componente para ConfirmDialog -->
			<!-- <ConfirmDialog :message="'Tem a certeza de que pretende apagar os dados desta turma?'" :model="showConfirm"></ConfirmDialog> -->
			<v-dialog v-model="showConfirm" persistent max-width="400">
				<v-card>
					<v-card-title class="headline">Atenção</v-card-title>
					<v-card-text>Tem a certeza de que pretende apagar os dados desta turma?</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="secondary" text @click="showConfirm = false">Cancelar</v-btn>
						<v-btn color="secondary" text @click="deleteConfirmed(editedItem); showConfirm = false;">Confirmar</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
        </v-toolbar>

		<v-layout class="pt-4">
			<v-flex xs3>
				<v-select
					v-model="anoLectivoSeleccionado"
					:items="anosLectivos"
					label="Ano lectivo"
					outlined>
				</v-select>
			</v-flex>
		</v-layout>

		<v-container v-if="!isLoading && turmasAnoLectivo.length === 0">
			<p class="text-center py-8">Sem turmas registadas.</p>
		</v-container>

		<v-list two-line v-if="turmasAnoLectivo.length > 0">
			<template v-for="(item, index) in turmasAnoLectivo">
				<div :key="item.id">
					<v-list-item :key="item.id" @click="goToAlunos(item.id)">
						<v-list-item-content>
							<v-list-item-title>{{item.ano}}.º {{item.designacao}}</v-list-item-title>
							<v-list-item-subtitle>{{ item.ano_lectivo | anoLectivoDesc }}</v-list-item-subtitle>
						</v-list-item-content>

						<v-list-item-action>
							<div>
								<v-layout justify-center fill-height>
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-btn icon ripple class="mx-2" v-on="on" v-if="isAdmin" @click="editItem(item)" @click.stop="">
												<v-icon color="secondary">edit</v-icon>
											</v-btn>
										</template>
										<span>Editar</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-btn icon ripple class="mx-2" v-on="on" v-if="isAdmin" @click="deleteItem(item)" @click.stop="">
												<v-icon color="secondary">delete</v-icon>
											</v-btn>
										</template>
										<span>Eliminar</span>
									</v-tooltip>

									<v-divider vertical></v-divider>

									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-btn icon ripple class="mx-2" v-on="on" @click="goToInformacoes(item.id)" @click.stop="">
												<v-icon color="secondary">description</v-icon>
											</v-btn>
										</template>
										<span>Informações</span>
									</v-tooltip>

									<v-divider vertical></v-divider>

									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-btn icon ripple class="mx-2" v-on="on" @click="goToAlunos(item.id)" @click.stop="">
												<v-icon color="secondary">group</v-icon>
											</v-btn>
										</template>
										<span>Alunos</span>
									</v-tooltip>
								</v-layout>
							</div>
						</v-list-item-action>
					</v-list-item>

					<v-divider :key="index" v-if="index < turmasAnoLectivo.length-1"></v-divider>
				</div>
			</template>
		</v-list>

		<v-divider></v-divider>
        <v-btn color="primary" text class="my-4" @click="goBack()">
            <v-icon left>arrow_back</v-icon>
            Voltar
        </v-btn>

		<Loading :isLoading="isLoading" />

		<error-dialog :show-dialog="this.errorMessage.show" :error-message="this.errorMessage"></error-dialog>
    </v-container>
</template>

<script>
    import Vue from 'vue'
    import StaticData from '../data/static-data.js';
	Vue.use(StaticData);

	import UserService from '@/services/user.service';
	const userService = new UserService();

	import Loading from "@/components/Loading";

    export default {
		components: {
			Loading
		},

        data: () => ({
            dialog: false,
			errorMessage: {
				show: false
			},
			showConfirm: false,
			isLoading: false,
			anosLectivos: StaticData.AnosLectivos,
			anosCurriculares: StaticData.AnosCurriculares,
			anoLectivoSeleccionado: StaticData.AnoLectivoActual,
            turmas: [],
            editedIndex: -1,
            editedItem: {
				ano_lectivo: StaticData.AnoLectivoActual,
				// escola: this.$route.params.escolaId,
                ano: '',
                designacao: ''
            },
            defaultItem: {
				ano_lectivo: StaticData.AnoLectivoActual,
				// escola: this.$route.params.escolaId,
                ano: '',
                designacao: ''
            },
            inputRules: {
                required: value => !!value || 'Campo obrigatório'
            }
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adicionar turma' : 'Editar turma'
			},
			isAdmin () {
				return userService.isAdmin();
			},
			turmasAnoLectivo () {
				return this.turmas.filter(t => t.ano_lectivo === this.anoLectivoSeleccionado);
			}
        },

        watch: {
            dialog (val) {
                val || this.resetEditedData()
            }
        },

        created () {
			this.escolaId = this.$route.params.escolaId,
			this.loadTurmas()
        },

        methods: {
			loadTurmas () {
				this.isLoading = true;

				this.$http.get(process.env.VUE_APP_API_ROOT + `/lista-turmas?escola_id=${this.escolaId}`).then(function(data){
                    return data.json();
                }).then(function(data){
                    // console.log(data);
                    this.turmas = data;

					this.isLoading = false;
                }, response => { // error callback
					this.isLoading = false;
				});
			},
            editItem (item) {
                this.editedIndex = this.turmas.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },
            deleteItem (item) {
                this.editedIndex = this.turmas.indexOf(item)
                this.editedItem = Object.assign({}, item)
				this.showConfirm = true;
            },
            resetEditedData () {
                this.dialog = false;
				this.editedItem = Object.assign({}, this.defaultItem);
				this.editedIndex = -1;
            },
            save () {
				this.isLoading = true;

                if (this.editedIndex > -1) {
					console.log(this.editedItem);
					this.$http.put(process.env.VUE_APP_API_ROOT + `/turma/${this.editedItem.id}/`, this.editedItem).then(function(data){
						console.log(data);
						this.submitted = true;

						Object.assign(this.turmas[this.editedIndex], this.editedItem);

						this.resetEditedData();

						this.isLoading = false;
					}, response => { // error callback
						console.log(response);

						this.errorMessage.message = "Ocorreu um erro ao editar os dados da turma.";
						this.errorMessage.show = true;

						this.isLoading = false;
					});
                } else {
					this.editedItem.escola = this.$route.params.escolaId;

					this.$http.post(process.env.VUE_APP_API_ROOT + '/turma/', this.editedItem).then(function(data){
						console.log(data);
						this.submitted = true;
						
						this.turmas.push(data.body);

						this.resetEditedData();

						this.isLoading = false;
					}, response => { // error callback
						console.log(response);

						this.errorMessage.message = "Ocorreu um erro ao gravar os dados da nova turma.";
						this.errorMessage.show = true;

						this.isLoading = false;
					});
                }
			},
			deleteConfirmed (item) {
				this.isLoading = true;

				this.$http.delete(process.env.VUE_APP_API_ROOT + `/turma/${item.id}/`).then(function(data){
					console.log(data);
					this.submitted = true;

					const index = this.turmas.indexOf(item);
					this.turmas.splice(index, 1);

					this.isLoading = false;
				}, response => { // error callback
					console.log(response);

					this.errorMessage.message = "Ocorreu um erro ao eliminar os dados da turma.";
					this.errorMessage.show = true;

					this.isLoading = false;
				});
			},
            goToInformacoes (turma_id) {
				// console.log(turma_id)
                this.$router.push({ name: 'turma-informacoes', params: { turmaId: turma_id }})
            },
            goToAlunos (turma_id) {
                this.$router.push({ name: 'lista-alunos', params: { turmaId: turma_id }})
            },
			goBack () {
                window.history.length > 1
                    ? this.$router.go(-1)
                    : this.$router.push('/')
            }
        }
    }
</script>